import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mail\"><path d=\"M917.504 213.312H104.576L509.12 461.568l408.384-248.256zm21.12 91.072l-429.76 260.48-.128.256L85.312 305.728v504.96h853.376V304.384zM0 128h1024v768H0V128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol